import { useCallback } from 'react';
import type { SubmitOptions, SurveyPaginationContext } from '../../types';
import { buildOnNextRunState } from './buildOnNextRunState';
import { goToNextVisiblePageOrSubmit } from './goToNextVisiblePageOrSubmit';
import { tryLeaveEmptyPage } from './tryLeaveEmptyPage';
import { trySkipLogicNavigation } from './trySkipLogicNavigation';
import type { OnNextSubmit } from './types';
import { validateCurrentPage } from './validateCurrentPage';

export function useOnNext(
  context: SurveyPaginationContext,
  onSubmit: OnNextSubmit
) {
  const { pages, currentPageIndex } = context;
  const currentPage = pages[currentPageIndex];
  const rawCurrentQuestions = currentPage?.questions ?? [];
  //   {survey,
  //   pages,
  //   values,
  //   setValues,
  //   currentPageIndex,
  //   setCurrentPageIndex,
  //   setPhase,
  //   setValidationErrors,
  //   trackPageTime,
  //   trackOptionalSkips,
  //   checkBacktrackChanges,
  //   paginationRefs,
  //   bumpProgressRevision,
  // } = context;

  return useCallback(() => {
    const run = buildOnNextRunState({
      context,
      onSubmit,
      currentPageIndex,
      rawCurrentQuestions,
    });

    if (!run) {
      return;
    }

    if (tryLeaveEmptyPage(run)) {
      return;
    }

    if (trySkipLogicNavigation(run)) {
      return;
    }

    if (!validateCurrentPage(run)) {
      return;
    }

    goToNextVisiblePageOrSubmit(run);
  }, [context, currentPageIndex, rawCurrentQuestions, onSubmit]);
}

export type { SubmitOptions };
